import { ContentPage } from '@/components/content-page'
import { LoginForm } from '@/components/login-form'

export default function LoginPage() {
  return (
    <ContentPage
      eyebrow="// account"
      title="Log in"
      description="Sign in to join the NewChirp community forums."
    >
      <div className="mx-auto w-full max-w-md">
        <LoginForm />
      </div>
    </ContentPage>
  )
}
